import {useInjection} from "inversify-react";
import {useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {BeerApi, BeerCreateDto, BeerDto, BeerUpdateDto, Direction} from "../../api";
import BeersList from "./beerList";
import BeerModalFormAddContainer from "./beerModalFormAddContainer/beerModalFormAddContainer";
import {Layout, notification} from "antd";
import {Content} from "antd/lib/layout/layout";
import styles from "./beerListContainer.module.scss";

export default function BeersListContainer() {
    const apiService = useInjection(ApiService);
    const [Beers, setBeers] = useState<BeerDto[] | null>();
    const [isAddFormVisible, setAddFormVisible] = useState(false);
    const [BeerModalFormContainerTitle, setBeerModalFormContainerTitle] = useState<string>();
    const [BeerToEdit, setBeerToEdit] = useState<BeerUpdateDto | null>(null);
    const [idBeerToEdit, setIdBeerToEdit] = useState<number | null>(null);

    useEffect(() => {
        refreshBeersList();
    }, [])

    const refreshBeersList = async () => {
        try {
            const beers = await apiService.getApi(BeerApi).apiBeerGet();
            let sortedBeers = beers.data.sort((a, b) => {
                return a.position! - b.position!
            })
            setBeers(sortedBeers)
        } catch (e: any) {
            console.log(e.response.data);
        }
    }

    const onAddClicked = () => {
        setBeerModalFormContainerTitle("Dodaj nowe piwo");
        setBeerToEdit(null);
        setIdBeerToEdit(null);
        setAddFormVisible(true);
    }

    const onEditClicked = async (id: number) => {
        setBeerModalFormContainerTitle(`Edytuj piwo`);

        const response = await apiService.getApi(BeerApi).apiBeerIdGet(id);

        setBeerToEdit(response.data as BeerUpdateDto);
        setIdBeerToEdit(id);
        setAddFormVisible(true);
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(BeerApi).apiBeerIdDelete(id)
        if (response.request.status !== 200) {
            console.log("Error occured while deleting data"); //add some warning?
        } else {
            refreshBeersList();
        }
    }

    const onPositionChangeClicked = async (id: number, direction: Direction) => {
        const beers = await apiService.getApi(BeerApi).apiBeerPositionIdDirectionPatch(id, direction);
        let sortedBeers = beers.data.sort((a, b) => {
            return a.position! - b.position!
        })
        setBeers(sortedBeers)
    }

    const openNotification = (message: string) => {
        notification.info({
            message: message,
            description:
                'Aby wprowadzone zmiany były widoczne na stronie konieczna jest publikacja',
            placement: "top"
        });
    };

    const onSubmit = async (values: BeerCreateDto | BeerUpdateDto) => {
        try {
            if (BeerToEdit === null) {
                await apiService.getApi(BeerApi).apiBeerPost(values);
                openNotification("Pomyślnie dodano nowy wpis");
            } else if (idBeerToEdit !== null) {
                values.position = BeerToEdit.position;
                await apiService.getApi(BeerApi).apiBeerIdPut(idBeerToEdit, values)
                openNotification("Pomyślnie zaktualizowano wpis");
            }
        } catch (e: any) {
            return e.response.data;
        }

        setAddFormVisible(false)
        refreshBeersList();
    }

    return <Layout style={{backgroundColor: "white"}}>
        <h1>Rodzaje piw</h1>
        <Content className={styles.content}>
            <BeersList
                data={Beers || null}
                onAddClicked={onAddClicked}
                onEditClicked={onEditClicked}
                onDeleteClicked={onDeleteClicked}
                onPositionChangeClicked={onPositionChangeClicked}
            />
            <BeerModalFormAddContainer
                onFinish={() => setAddFormVisible(false)}
                onSubmit={onSubmit}
                addFormVisibility={isAddFormVisible}
                title={BeerModalFormContainerTitle || ""}
                BeerToEdit={BeerToEdit}
            />
        </Content>
    </Layout>;
}
